<div class="app" dir="ltr">
    <div class="main-header">
      <div class="branding">
        <div class="app-header__brand">
          <span class="app-header__logo">audit</span>
          <span class="app-header__divider">|</span>
          <img src="assets/images/svg/Logo-black.png" alt="Swipesum Logo" class="app-header__partner">
        </div>
      </div>
    </div>
</div>
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
